import { ACTIVE_TAB_EVERYTHING, FILTER_COMMENTS_ITEMS } from "../actions/constants";
import { COMMENTS } from "../actions/types";

const initialState = {
  error: null,
  data: {
    comments: [],
    team_members: [],
  },
  isLoading: false,
  selectedFilter: FILTER_COMMENTS_ITEMS.ALL_COMMENTS,
  selectedTab: ACTIVE_TAB_EVERYTHING,
  showResolvedComments: false,
};

const parentCommentExtraModel = {
  read_status: [],
  reactions: [],
  replies: [],
};

const replyCommentExtraModel = {
  reactions: [],
};

const commentsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case COMMENTS.LOAD:
      return { ...initialState, isLoading: false, ...payload };

    case COMMENTS.UPDATE:
      return { ...state, isLoading: false, error: null, ...payload };

    case COMMENTS.ERROR:
      return { ...state, isLoading: false, error: null, ...payload };

    case COMMENTS.RESET:
      return initialState;

    case COMMENTS.ADD_COMMENT: {
      const comment = payload?.data?.model;
      if (!comment) return state;

      const readStatus = payload?.data?.read_status;

      const newData = { ...state.data };
      const comments = newData.comments ? [...newData.comments] : [];

      if (comment.parent_id) {
        const parentCommentIndex = comments.findIndex((p) => Number(p?.comment?.id) === Number(comment.parent_id));
        if (parentCommentIndex !== -1) {
          const parentComment = comments[parentCommentIndex];
          parentComment.replies = [...parentComment.replies, { comment, ...replyCommentExtraModel, reactions: [] }];
          parentComment.read_status = readStatus;
        }
      } else {
        comments.unshift({ comment, ...{ ...parentCommentExtraModel, read_status: readStatus, reactions: [] } });
      }

      newData.comments = comments;
      return { ...state, data: newData, isLoading: false, error: null };
    }

    case COMMENTS.UPDATE_COMMENT: {
      const comment = payload?.data?.model;
      if (!comment) return state;

      const readStatus = payload?.data?.read_status;

      const newData = { ...state.data };
      const comments = newData.comments ? [...newData.comments] : [];

      if (comment.parent_id) {
        const parentCommentIndex = comments.findIndex((p) => Number(p?.comment?.id) === Number(comment.parent_id));
        if (parentCommentIndex !== -1) {
          const parentComment = comments[parentCommentIndex];
          if (parentComment.replies) {
            const replyIndex = parentComment.replies.findIndex((r) => Number(r?.comment.id) === Number(comment.id));
            if (replyIndex !== -1) {
              const updatedReply = { ...parentComment.replies[replyIndex], comment };
              parentComment.replies = [
                ...parentComment.replies.slice(0, replyIndex),
                updatedReply,
                ...parentComment.replies.slice(replyIndex + 1),
              ];
            }
          }
          parentComment.read_status = readStatus;
        }
      } else {
        const commentIndex = comments.findIndex((c) => Number(c?.comment?.id) === Number(comment.id));
        if (commentIndex !== -1) {
          const updatedComment = { ...comments[commentIndex], comment, read_status: readStatus };
          comments[commentIndex] = updatedComment;
        }
      }

      newData.comments = comments;
      return { ...state, data: newData, isLoading: false, error: null };
    }

    case COMMENTS.UPDATE_REACTION: {
      const reaction = payload?.data?.model;
      if (!reaction) return state;

      const newData = { ...state.data };
      const comments = newData.comments ? [...newData.comments] : [];

      const comment = comments.find((c) => Number(c?.comment?.id) === Number(reaction.comment_id));
      if (comment) {
        if (comment.reactions) {
          const reactionIndex = comment.reactions.findIndex((r) => Number(r.id) === Number(reaction.id));
          if (reactionIndex !== -1) {
            comment.reactions[reactionIndex] = { ...comment.reactions[reactionIndex], ...reaction };
          } else {
            comment.reactions.unshift(reaction);
          }
        }
      } else {
        comments.forEach((comment) => {
          if (comment.replies) {
            const replyIndex = comment.replies.findIndex((r) => Number(r.comment.id) === Number(reaction.comment_id));
            if (replyIndex !== -1) {
              const reply = comment.replies[replyIndex];
              if (reply && reply.reactions) {
                const reactionIndex = reply.reactions.findIndex((r) => Number(r.id) === Number(reaction.id));
                if (reactionIndex !== -1) {
                  reply.reactions[reactionIndex] = { ...reply.reactions[reactionIndex], ...reaction };
                } else {
                  reply.reactions.unshift(reaction);
                }
              }
            }
          }
        });
      }

      newData.comments = comments;
      return { ...state, data: newData, isLoading: false, error: null };
    }

    case COMMENTS.MARK_AS_READ: {
      const readStatus = payload?.data?.model;
      if (!readStatus) return state;

      const newData = { ...state.data };
      const comments = newData.comments ? [...newData.comments] : [];

      const commentIndex = comments.findIndex((c) => Number(c?.comment?.id) === Number(readStatus.comment_id));
      if (commentIndex !== -1) {
        const readStatusIndex = comments[commentIndex].read_status?.findIndex((r) => Number(r.id) === Number(readStatus.id));
        if (readStatusIndex !== -1) {
          comments[commentIndex].read_status[readStatusIndex] = readStatus;
        }
      }

      newData.comments = comments;
      return { ...state, data: newData, isLoading: false, error: null };
    }

    case COMMENTS.SET_SELECTED_FILTER:
      return { ...state, selectedFilter: payload };

    case COMMENTS.SET_SELECTED_TAB:
      return { ...state, selectedTab: payload };

    case COMMENTS.SET_SHOW_RESOLVED_COMMENTS:
      return { ...state, showResolvedComments: payload };

    default:
      return state;
  }
};

export default commentsReducer;
